const trustItems = [
  { icon: "ri-refresh-line", text: "Updated Daily Listings" },
  { icon: "ri-shield-check-line", text: "Verified Spreadsheet Sources" },
  { icon: "ri-guide-line", text: "Safe Proxy Shopping Explained" },
  { icon: "ri-user-star-line", text: "Beginner Friendly System" },
];

export default function TrustStrip() {
  return (
    <section className="bg-background-100 border-y border-background-200/60">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-5">
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-10">
          {trustItems.map((item) => (
            <div key={item.text} className="flex items-center gap-2 text-sm text-foreground-700">
              <span className="w-5 h-5 flex items-center justify-center text-accent-500">
                <i className={`${item.icon} text-base`} />
              </span>
              <span className="whitespace-nowrap">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}